module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('title-component', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('key-indicators-component', {
    attrs: {
      "resultData": _vm.resultData,
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('business-trends-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c34d374","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/serviceData/Main.vue
// module id = 799
// module chunks = 0